export default __webpack_public_path__ + "static/media/-W_8XJnvUD7dzB2Cy_gIZmMuUZctdhow.21ab3ecd.woff2";